import React from "react";
import { UpwardArrow } from "./UpArrowGreen.styles";

const DownArrow = () => {
    return (
        <UpwardArrow />
    )
}

export default DownArrow;